<template>
  <div class="wl-keys" @pointerdown.stop @click.self="emit('close')">
    <div class="wl-keys__panel" role="dialog" aria-label="快捷键说明">
      <div class="wl-keys__head">
        <h3>快捷键说明</h3>
        <button type="button" title="关闭 (Esc)" @click="emit('close')"><CloseOutlined /></button>
      </div>
      <div v-for="(row, rowIndex) in rows" :key="rowIndex" class="wl-keys__row">
        <span v-for="(key, keyIndex) in row" :key="keyIndex" class="wl-keys__key" :class="[key.kind, { blank: !key.label }]" :style="{ flex: key.width || 1 }">
          <b>{{ key.label }}</b><small>{{ key.desc }}</small>
        </span>
      </div>
      <ul class="wl-keys__text">
        <li><b>[X]</b> 切换虚拟飞行器速度</li>
        <li><b>[V]</b> 切换视角是否跟随飞行器</li>
        <li><b>[~]</b> 主画面切换第一视角</li>
        <li><b>[F]</b> 在当前虚拟飞行器位置添加定向拍照</li>
        <li><b>[Space]</b> 在当前虚拟飞行器位置添加航点（插入到选中航点之后）</li>
        <li><b>[I] / [K]</b> 云台抬头 / 低头</li>
        <li><b>[Delete]</b> 删除选中航点</li>
        <li><b>[Ctrl/⌘ + Z]</b> 撤销</li>
        <li><b>[Esc]</b> 关闭面板 / 取消当前工具</li>
        <li><b>鼠标</b> 拖动地图平移，滚轮缩放，按住 Ctrl 拖动旋转视角；在相机预览窗上滚动调整云台俯仰；拖动地图上的航点可移动航点</li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts" setup>
/* global defineEmits */
import { CloseOutlined } from '@ant-design/icons-vue'

const emit = defineEmits(['close'])

type Key = { label?: string; desc?: string; kind?: 'view' | 'move' | 'action' | 'gimbal' | 'nav'; width?: number }
const blank: Key = {}
const rows: Key[][] = [
  [{ label: '~', desc: '切换视角', kind: 'view' }, { label: '1', desc: '广角镜头', kind: 'view' }, { label: '2', desc: '变焦镜头', kind: 'view' }, blank, blank, blank, blank, blank, blank, blank, blank, { width: 1.6 }],
  [{ width: 1.4 }, { label: 'Q', desc: '左旋', kind: 'move' }, { label: 'W', desc: '前进', kind: 'move' }, { label: 'E', desc: '右旋', kind: 'move' }, blank, blank, blank, { label: 'I', desc: '云台抬头', kind: 'gimbal' }, blank, blank, blank, { width: 1.2 }],
  [{ width: 1.8 }, { label: 'A', desc: '左移', kind: 'move' }, { label: 'S', desc: '后退', kind: 'move' }, { label: 'D', desc: '右移', kind: 'move' }, { label: 'F', desc: '定向拍照', kind: 'action' }, blank, blank, { label: 'K', desc: '云台低头', kind: 'gimbal' }, blank, blank, { width: 1.8 }],
  [{ label: 'Shift', desc: '组合键', kind: 'view', width: 2.3 }, { label: 'Z', desc: '下降', kind: 'move' }, { label: 'X', desc: '速度切换', kind: 'view' }, { label: 'C', desc: '上升', kind: 'move' }, { label: 'V', desc: '视角跟随', kind: 'view' }, blank, blank, blank, { label: '?', desc: '帮助', kind: 'view' }, { width: 2.3 }],
  [blank, blank, blank, { label: 'Space', desc: '新增航点', kind: 'action', width: 5 }, blank, blank, { label: '◀', desc: '上一航点', kind: 'nav' }, { label: '▲▼', desc: '上/下一动作', kind: 'nav' }, { label: '▶', desc: '下一航点', kind: 'nav' }],
]
</script>

<style lang="scss">
.wl-keys {
  position: absolute; inset: 0; z-index: 5; display: flex; align-items: center; justify-content: center; background: #00000080; pointer-events: auto;
  &__panel { width: min(900px, calc(100vw - 80px)); padding: 16px 22px 18px; border-radius: 8px; background: #1b1c1ff2; border: 1px solid #35373c; box-shadow: 0 12px 40px #000c; }
  &__head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 14px; }
  &__head h3 { margin: 0; color: #fff; font-size: 15px; }
  &__head button { width: 28px; height: 28px; border: 0; border-radius: 4px; background: transparent; color: #fff; font-size: 16px; cursor: pointer; }
  &__head button:hover { background: #ffffff1f; }
  &__row { display: flex; gap: 6px; margin-bottom: 6px; }
  &__key { display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 54px; border-radius: 4px; background: #4a4d55; color: #fff; text-align: center; padding: 4px; }
  &__key b { font-size: 14px; }
  &__key small { font-size: 11px; color: #ffffffd9; }
  &__key.blank { background: #35373c; }
  &__key.view { background: #6b3fa0; }
  &__key.move { background: #2f5f9e; }
  &__key.action { background: #7a3fa0; }
  &__key.gimbal { background: #2e7d5b; }
  &__key.nav { background: #3a3c42; }
  &__text { margin: 12px 0 0; padding: 0; list-style: none; display: flex; flex-wrap: wrap; gap: 4px 18px; color: #d5d8de; line-height: 1.7; }
  &__text b { color: #fff; font-weight: 600; margin-right: 4px; }
}
</style>
